export default {
  login: "/login",
  authCallback: "/auth/callback",
  customers: "/customers",
  customer: "/customers/:id",
  dashboard: "/",
  recentActivity: "/recentActivity",
  applications: {
    list: "/applications",
    show: "/applications/:id"
  },
  policies: {
    list: "/policies",
    show: "/policies/:id"
  },
  quotes: {
    productSelection: "/quote/product",
    auto: {
      quick: {
        policyGeneral: "/quote/auto/quick/policy",
        driverDetail: "/quote/auto/quick/drivers",
        vehicleDetail: "/quote/auto/quick/vehicles",
        estimatedPremium: "/quote/auto/quick/estimate"
      },
      policyGeneral: "/quote/auto/policy",
      insuredInformation: "/quote/auto/insured",
      qualificationQuestions: "/quote/auto/questions",
      driverDetail: "/quote/auto/drivers",
      vehicleDetail: "/quote/auto/vehicles",
      paymentPlans: "/quote/auto/payment",
      confirmation: "/quote/auto/confirmation"
    },
    homeowner: {
      quick: {
        policyGeneral: "/quote/homeowner/quick/policy",
        coverage: "/quote/homeowner/quick/coverage",
        estimate: "/quote/homeowner/quick/estimate"
      },
      policyGeneral: "/quote/homeowner/policy",
      insuredInformation: "/quote/homeowner/insuredInformation",
      qualificationQuestions: "/quote/homeowner/qualificationQuestions",
      propertyDetails: "/quote/homeowner/propertyDetails",
      detail: "/quote/homeowner/detail",
      additionalInterests: "/quote/homeowner/additionalInterests",
      paymentPlans: "/quote/homeowner/payment",
      confirmation: "/quote/homeowner/confirmation"
    }
  },
  search: "/search",
  tasks: "/tasks"
};
